import { Box, Button, CircularProgress, Link as MaterialLink, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Trans } from "react-i18next"
import { Link } from "react-router-dom";
import { useGetAssignmentsQuery } from "../../store/service/serviceSlice";
import { useCallback, useEffect } from "react";
import { useGetUserAssignmentScoresQuery, useLazyGetAssignmentUserSolutionQuery } from "../../store/data/dataSlice";

const AssignmentsTable = (): JSX.Element => {
    const assignments = useGetAssignmentsQuery(undefined);
    const scores = useGetUserAssignmentScoresQuery();


    const getScore = (assignment_title: string) => {
        let result = "-";
        if (scores.data) {
            scores.data.forEach((score) => {
                if(score.assignment_title == assignment_title) {
                    result = (score.score).toString();
                }
            })
        }
        return result;
    }

    const current_time = new Date().valueOf() - (new Date().getTimezoneOffset())*60000;

    const formatTime = (time: string) => {
        const date = time.split('T')[0].split('-');
        const date_time = time.split('T')[1].split('.')[0];

        return date[2] + '.' + date[1] + '.' + date[0] + ', ' + date_time;
    }

    const formatDeadline = (time: number, deadline: number) => {
        const difference_ms = deadline - time;
        const difference_hours = ((difference_ms/1000)/60)/60
        const difference_days = difference_hours/24;

        const days = Math.floor(difference_days);
        const hours = Math.floor((difference_days - days)*24);
        const minutes = Math.floor((difference_hours - Math.floor(difference_hours))*60);

        if(difference_ms <= 0) return (<Typography> - </Typography>)
        else return (<Typography>{days}d {hours}h {minutes}m</Typography>);
    }

    return (
        <TableContainer>
            <Table sx={{ maxWidth: 1000}} aria-label={'test'}>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Trans>Name</Trans>
                        </TableCell>
                        <TableCell>
                            <Trans>Due in</Trans>
                        </TableCell>
                        <TableCell>
                            <Trans>Due Date</Trans>
                        </TableCell>
                        <TableCell>
                            <Trans>Score</Trans>
                        </TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!assignments.isLoading && assignments.data ? (
                        assignments.data.assignments.map(assignment => (
                            <TableRow>
                                <TableCell>
                                    <MaterialLink underline={'hover'} component={Link} to={`/assignments/${assignment.title}`}>
                                        {assignment.title}
                                    </MaterialLink>
                                </TableCell>
                                <TableCell>
                                    {formatDeadline(current_time, new Date(assignment.deadline_on).valueOf())}
                                </TableCell>
                                <TableCell>
                                    {formatTime(assignment.deadline_on)}
                                </TableCell>
                                <TableCell>
                                    {!scores.isLoading && scores.data ? (<Typography>{getScore(assignment.title)} / 20.0</Typography>) : (<Typography> - / 20.0 </Typography>)}
                                </TableCell>
                                <TableCell>
                                    {getScore(assignment.title) !== "-" ? (
                                        <Button variant={'outlined'} color={'success'} component={Link} to={`/assignments/${assignment.title}/review`}>
                                            Review
                                        </Button>
                                    ) : (
                                        <></>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))
                    ) : 
                    (
                        <Box sx={{ p: 2 }}>
                            <CircularProgress />
                        </Box>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default AssignmentsTable;